module.exports = __webpack_public_path__ + "img/Crayons.104e2d0c.svg";